// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__VlVBZ","col":"styles_col__2e_8M"};